import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/trash'),
    name: 'trash_items',
    component: () => import('./Index.vue'),
    meta: { permissions: ['administrator', 'trash_manage'] },
  },
];
